import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import {
  Folder,
  FolderOpen,
  Users,
  Building,
  Scale,
  FileText,
  Briefcase,
  Home,
  Star,
  Archive,
  FolderArchive,
  FolderCheck,
} from 'lucide-react';

const FOLDER_ICONS = [
  { id: 'folder', name: 'Pasta Padrão', Icon: Folder },
  { id: 'folder-open', name: 'Pasta Aberta', Icon: FolderOpen },
  { id: 'folder-archive', name: 'Arquivo', Icon: FolderArchive },
  { id: 'folder-check', name: 'Concluído', Icon: FolderCheck },
  { id: 'users', name: 'Cliente/Equipe', Icon: Users },
  { id: 'building', name: 'Empresa', Icon: Building },
  { id: 'scale', name: 'Jurídico', Icon: Scale },
  { id: 'briefcase', name: 'Trabalho', Icon: Briefcase },
  { id: 'file-text', name: 'Documentos', Icon: FileText },
  { id: 'home', name: 'Imobiliário', Icon: Home },
  { id: 'star', name: 'Favorito', Icon: Star },
  { id: 'archive', name: 'Arquivo Morto', Icon: Archive },
];

interface FolderIconSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export function FolderIconSelector({ value, onChange }: FolderIconSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Ícone da Pasta</Label>
      <div className="grid grid-cols-4 gap-2">
        {FOLDER_ICONS.map(({ id, name, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(id);
            }}
            className={cn(
              "flex items-center justify-center h-12 rounded-md transition-all",
              "border-2 hover:bg-accent",
              value === id
                ? "border-primary bg-accent"
                : "border-muted"
            )}
            title={name}
          >
            <Icon className="h-5 w-5" />
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        {FOLDER_ICONS.find(i => i.id === value)?.name || 'Selecione um ícone'}
      </p>
    </div>
  );
}
